import moment from "moment"
import { apolloVuexListStoreFactory } from '../../../libs/ApolloVuexListStore'

import { DM_NEWS_QUERY } from "./graphql";

/* eslint-disable no-unused-vars */
let store = apolloVuexListStoreFactory({
  settings: {
    fetchAllQuery: DM_NEWS_QUERY,
    fetchAllFieldName: 'dmNews',
  },
  actions: {
    checkShowLastDMNews({ commit, getters, rootState }) {
      let news = getters.withIsUnread.filter(entry => entry.newsType == 'DESTINATIONMANAGER')
          .sort((a, b) => moment(a.significantUpdateAt).diff(moment(b.significantUpdateAt)));
      let lastNewsId = news.length > 0 ? String(news.slice(-1)[0].id) : null;

      if (lastNewsId !== rootState.uiStore.lastArticleId) {
        commit('uiStore/SET_SHOW_LAST_DM_NEWS', true, { root: true });
      }

      return lastNewsId
    }
  },
  getters: {
    withIsUnread(state, getters, rootState) {
      let news = []
      for (let entry of state.entries) {
        entry.isUnread = false
        if (moment(entry.createdAt) > rootState.uiStore.lastNewsVisitDate) {
          entry.isUnread = true
        }
        news.push(entry)
      }
      return news
    },

  }
})
/* eslint-enable no-unused-vars */

export default store

